export default {
  title: 'Nebula buds AI 통화', // "Nebula buds AI通话" 翻译为韩语
  userID: '사용자 ID : ', // "用户ID : "
  hurryUp: '상대방의 전화를 기다리는 중', // "等待对方呼叫"
  waitingCall: '이 페이지에서 상대방의 전화를 기다리고 있습니다. 페이지를 미리 닫지 마세요.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: '자막 스위치', // "字幕开关"
  initWait: '초기화 대기 중', // "等待初始化"
  initSuccess: '초기화 완료, 상대방의 전화를 기다립니다. 페이지를 닫지 마세요!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: '전화 연결됨', // "电话接通"
  callEnd: '전화 종료', // "通话结束"
  careful: '주의 : ', // "注意 : "
  wait: '통화 컴포넌트 준비 완료, 상대방의 전화를 기다리는 중', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: '아랍어', // "阿拉伯语"
    da: '덴마크어', // "丹麦语"
    de: '독일어', // "德语"
    en: '영어', // "英语"
    es: '스페인어', // "西班牙语"
    fil: '필리핀어', // "菲律宾语"
    fr: '프랑스어', // "法语"
    hi: '힌디어', // "印地语"
    id: '인도네시아어', // "印度尼西亚语"
    it: '이탈리아어', // "意大利语"
    ja: '일본어', // "日文"
    ko: '한국어', // "韩语"
    ms: '말레이어', // "马来语"
    no: '노르웨이어', // "挪威语"
    pt: '포르투갈어', // "葡萄牙语"
    ru: '러시아어', // "俄语"
    sv: '스웨덴어', // "瑞典语"
    th: '태국어', // "泰语"
    tr: '터키어', // "土耳其语"
    vi: '베트남어', // "越南语"
    zh: '중국어' // "中文"
  }
}
